export default __webpack_public_path__ + "static/media/share.176f8da1.svg";